import Chart from "../../../Components/Chart";
import Note from "../../../Components/Note";
import Shortcut from "../../../Components/Shortcuts";
import Messages from "../../../Components/Messages";
import Cartable from "../../../Components/Cartable";
import { useContext, useEffect, useState } from "react";
import Card, { CardHeader, CardBody } from "../../../Components/Card";
import Modal, { ModalBody, ModalHeader } from "../../../Components/Modal";
import "./Dashboard.scss";
import Widget from "../../../Components/Widget";
import { WidgetItem } from "../../../Components/Widget";
// import { icon } from "@fortawesome/fontawesome-svg-core";
import { useOutletContext, useParams } from "react-router-dom";
import axios from "axios";

import { ReactTabulator } from "react-tabulator";
import Table from "../../../Components/Table/Table";
import FastPrint from "../../../Components/FastPrint";

export default function Dashboard(props) {
  let widgetArray = [
    {
      element: {
        type: "icon",
        value: "fa fa-pencil",
      },
      title: "Edited Docs",
      text: "250",
    },

    {
      element: {
        type: "icon",
        value: "fa fa-trash",
      },
      title: "Trash Docs",
      text: "160",
    },
  ];
  const [showAdminReport, setShowAdminReport] = useState(false);

  function setDateFu() {
    Date.today().add(-30).days(); // or...
    Date.today().add({ days: -30 });
  }
  useEffect(() => {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/lastUpdate/`,

      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setVersionModalIsOpen(response.data.lastUpdate);
      setNewVersion(response.data);
      setShowAdminReport(response.data.manager)
    });
  }, []);
  const [versionModalIsOpen, setVersionModalIsOpen] = useState(false);
  const [newVersion, setNewVersion] = useState("");
  function versionModalIsOpenCallbackHandler({ isOpen }) {
    setVersionModalIsOpen(isOpen);
  }
  const [titleInDashboard, setTitleInDashboard] = useState(" در حال بارگزاری");

  return (
    <div className="dashboard">
      <div className="dashboard-title">
        <h1>پیشخوان</h1>{" "}
      </div>
      <div className="dashboard-container">
        <Modal
          isOpen={versionModalIsOpen}
          modalCallback={versionModalIsOpenCallbackHandler}
        >
          <ModalHeader />
          <ModalBody>
            <span>
              نسخه{" "}
              {newVersion.lastUpdate !== undefined &&
                newVersion.lastUpdate.version}{" "}
              منتشر شد
            </span>
            <p>
              <i className="fas fa-circle"></i>
              {newVersion.lastUpdate !== undefined &&
                newVersion.lastUpdate.message}
            </p>
          </ModalBody>
        </Modal>
        {/* <Widget>
          {widgetArray.map(({ title, text, element }, index) => (
            <Card key={index} className="widget">
              <CardBody>
                <WidgetItem title={title} text={text} element={element} />
              </CardBody>
            </Card>
          ))}
        </Widget> */}

        {/* <Card className="message">
          <CardHeader>
            <h6 className="card-title">پیام ها</h6>
          </CardHeader>
          <CardBody>
            <Messages />
          </CardBody>
        </Card> */}
        <Card className="shortcut">
          <CardHeader>
            <h6 className="card-title">میان برها</h6>
          </CardHeader>
          <CardBody>
            <Shortcut ShowAdminReport={showAdminReport}/>
          </CardBody>
        </Card>
        {/* <Card className="chart">
          <CardHeader>
            <h6 className="card-title">گزارشات</h6>
          </CardHeader>
          <CardBody>{/* <Chart id={3} /> */}
        {/* </CardBody> */}
        {/* </Card> */}
        <Card className="note">
          <CardHeader>
            <h6 className="card-title">بارکد سریع </h6>
          </CardHeader>
          <CardBody>
            {/*<Note />*/}
            <FastPrint />
          </CardBody>
        </Card>
        <Card className="product-list" style={{ gridArea: "productTable" }}>
          <CardHeader>
            <h5 className="card-title">{titleInDashboard}</h5>
          </CardHeader>
          <CardBody>
            <Table
              id="1-s"
              height="52vh"
              hideColumns={[
                "na_88",
                "na_173",
                "na_214",
                "na_243",
                "na_290",
                "na_327",
                "na_332",
                "na_375",
                "na_389",
                "na_412",
              ]}
              setTitleInDashboard={setTitleInDashboard}
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
